import React from "react";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import CustomTypography from "../../../ui/widgets/typography";
import GridContainerItem from "../../../ui/layout/page/container-item";
import { useMessageSource } from "react-message-source";
import { ProductFamily } from "../../../context/product-context/product-family";
import ProductFamilyOption from "./product-family-option";
import { Product } from "../../../context/product-context/product";
import ProductImage from "../../shared/components/product-image";

interface FamilySelectionContentProps {
  families: ProductFamily[];
  handleOnProductFamilySelection: (product: Product) => void;
  handleDialogClose?: () => void;
}

export const ProductFamilySelectionContent = ({
  families,
  handleOnProductFamilySelection,
  handleDialogClose,
}: FamilySelectionContentProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  const renderProductImages = (family: ProductFamily): React.JSX.Element[] => {
    return family.products.map((product: Product) => (
      <ProductImage key={product.productRef} product={product.productRef} />
    ));
  };

  const renderFamilyOptions = (): React.JSX.Element[] => {
    return families
      .filter((family) => family.shouldBeShown)
      .map((family: ProductFamily) => {
        const defaultProductForFamily = family.getDefaultProduct();
        return (
          <ProductFamilyOption
            key={family.name}
            handleOnProductFamilySelection={handleOnProductFamilySelection}
            defaultProductForFamily={defaultProductForFamily}
            handleDialogClose={handleDialogClose}
            renderProductFamilyImage={() => <>{renderProductImages(family)}</>}
            productFamilyDescription={getMessage(
              `${family.translationKey}.image-description`,
            )}
          />
        );
      });
  };

  return (
    <>
      <TypographyItemContainer>
        <CustomTypography variant="body1">
          {getMessage("ProductFamily.subtitle")}
        </CustomTypography>
      </TypographyItemContainer>
      <GridContainerItem>{renderFamilyOptions()}</GridContainerItem>
    </>
  );
};
